export enum LocaleKeyEnum {
  enUS = 'en-US',
  deDE = 'de-DE',
  frFR = 'fr-FR',
}
